import { useMelwaysLink } from '@seek/melways-react';
import type { Language } from '@seek/melways-sites';
import {
  SALES_PHONE_NUMBER,
  EMPLOYER_CONTACT_US_URL_PROPS,
} from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Alert, ContentBlock, Text, TextLink } from 'braid-design-system';
import type React from 'react';

import { useAppContext } from '../../context/AppContext';
import { isAnz } from '../../utils/isAnz';

import translations from './.vocab';

const LargerBudgetPurchaseAlert: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslations(translations);
  const { country, site, language } = useAppContext();
  const localize = useMelwaysLink();

  const localisedUrl = localize({
    path: EMPLOYER_CONTACT_US_URL_PROPS.path,
    language: language as Language,
  });

  return (
    <ContentBlock>
      <Alert tone="promote">
        <Text>
          {t('to buy a larger budget and get...')}{' '}
          {isAnz(country) ? (
            t('reach out to our sales team on...', {
              salesNumber:
                SALES_PHONE_NUMBER[site as keyof typeof SALES_PHONE_NUMBER],
            })
          ) : (
            <TextLink href={localisedUrl} target="_blank">
              {t('get in touch with us')}
            </TextLink>
          )}
        </Text>
      </Alert>
    </ContentBlock>
  );
};

export default LargerBudgetPurchaseAlert;
